var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loaded),
      expression: "loaded"
    }],
    staticClass: "order-note bg-white pay-success"
  }, [(!_vm.oldUser) ? _c('div', {
    staticClass: "success"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/payicon.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v(_vm._s(_vm.tips))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "actions"
  }, [(!_vm.oldUser) ? _c('p', {
    staticStyle: {
      "margin-top": "5px",
      "padding": "0 50px"
    },
    domProps: {
      "textContent": _vm._s(_vm.messageTitle)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.oldUser) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.completed),
      expression: "completed"
    }],
    staticClass: "qr-image"
  }, [_c('img', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "src": _vm.qrsrc
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.oldUser) ? _c('div', {
    staticClass: "old-user user-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.avatar
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.oldUser) ? _c('div', {
    staticClass: "old-user user-name text"
  }, [_c('div', [_vm._v("恭喜您，服务已开通")]), _vm._v(" "), _c('div', [_vm._v("请在此头像对应的微信号" + _vm._s(_vm.username) + "内查看")])]) : _vm._e(), _vm._v(" "), (_vm.oldUser) ? _c('img', {
    staticClass: "old-user user-bg",
    attrs: {
      "src": "/static/img/done_head_bg.png"
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.completed),
      expression: "completed"
    }],
    staticStyle: {
      "margin": "10px 0",
      "padding": "0 60px",
      "font-size": "13px"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.bottomTips) + "\n\t\t\t")])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-8a55193a","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/customer/OrderPurchaseDone.vue
// module id = 244
// module chunks = 0